module.exports = __webpack_public_path__ + "img/newsIndImg5.de6099d7.png";